module.exports = __webpack_public_path__ + "img/Mongolia_Badges_01_Aimag_Khovsgol_a.bc9b9a9c.svg";